import { useTranslationWithSelfFallback } from '@i18n/useTranslationWithSelfFallback';
import { ArrowRight } from '@phosphor-icons/react';
import {
  MegaMenuLevels,
  trackMegaMenuNavigation,
} from '_utils/GA4/trackMegaMenuEvents';
import { useMegaMenuMobile } from '@hooks/useMegaMenuMobile';
import { MENU_PATH_DELIMITER } from '_utils/GA4/trackMegaMenuEvents';
import styles from './Mobile.module.scss';

export function LinksPanel() {
  const { activeItem, activeColumn, handleBack, handleClose } =
    useMegaMenuMobile();
  const t = useTranslationWithSelfFallback('common');

  return (
    <div className={styles.Panel} role="group" aria-label={activeColumn?.title}>
      <div className={styles.BackSection}>
        <button className={styles.BackLink} onClick={handleBack}>
          {activeItem?.label
            ? t('header.menu.backTo', { name: activeItem.label.toLowerCase() })
            : t('header.menu.back')}
        </button>
        {activeColumn &&
          (activeColumn.titleUrl ? (
            <a
              href={activeColumn.titleUrl}
              className={styles.PanelTitle}
              onClick={() => {
                trackMegaMenuNavigation({
                  level: MegaMenuLevels.level_2,
                  linkUrl: activeColumn.titleUrl,
                  linkText: activeColumn.title,
                  menuPath: `${activeItem?.label}${MENU_PATH_DELIMITER}${activeColumn.title}`,
                });
                handleClose();
              }}
            >
              {activeColumn.title}
              <ArrowRight size={24} />
            </a>
          ) : (
            <span className={styles.PanelTitle}>{activeColumn.title}</span>
          ))}
      </div>
      <div className={styles.LinksSection}>
        <hr className={styles.Divider} />
        <ul className={styles.LinkList}>
          {activeColumn &&
            activeColumn.links.map((link) => (
              <li key={link.url} className={styles.LinkListItem}>
                <a
                  href={link.url}
                  className={styles.SimpleLink}
                  onClick={() => {
                    trackMegaMenuNavigation({
                      level: MegaMenuLevels.level_4,
                      linkUrl: link.url,
                      linkText: link.label,
                      menuPath: `${activeItem?.label}${MENU_PATH_DELIMITER}${activeColumn.title}${MENU_PATH_DELIMITER}${link.label}`,
                    });
                    handleClose();
                  }}
                >
                  {link.label}
                </a>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}
